<template>
  <div class="Presonal-Info-container">
    <div v-if="this.$store.getters.isAuthenticated == true" style='display:flex;flex-wrap:wrap;justify-content:space-between'>
      <div class='billing-shipping-containers'>
        <div class="personal-info-titles">{{$translation($websiteText().checkout_generals_billing_details)}}</div>
        <billing-address-form
          :data_="billingAddress"
          :showSave="false"
          :disabled="$store.getters.status_id!=1"
          @validated="onValidated(true)"
        />
      </div>
      <div class='billing-shipping-containers'>
        <div class="personal-info-titles">{{$translation($websiteText().checkout_generals_shipping_details)}}</div>
        <DeliveryAddress ref="deliveryAddress"/>
      </div>
    </div>
    <div v-else>
      <div class="title-personnal-info">
        You can use your account, fill in details or check out as a guest
      </div>
      <div v-if="ErrosLogin == true">
        <t-inline-message
          :message="'login or create account before'"
          severity="error"
        />
      </div>
      <div class="type-of-login">
        <t-button
          v-for="(tab, index) in tabs"
          :label="tab.label"
          :onClick="() => onTabClick(index)"
          :color="tab.isActive ? 'primary' : 'light'"
          :key="index"
        ></t-button>
      </div>
      <div class="display-info-login">
        <keep-alive>
          <component :is="$store.getters.personnalInfoComponent"></component>
        </keep-alive>
      </div>
    </div>
    <div playwright-id='go-to-delivery-payment'>
      <t-button
        :label="$translation($websiteText().checkout_generals_continue_to_delivery_payment)"
        :disabled="$store.getters.status_id==2"
        :buttonClass="'btn-next submit-button'"
        color="primary-color"
        @click="submit()"
      />
    </div>
    <button style="display:none" id='submit1' form="billing_address_form">Submit1</button>
    <button style="display:none" id='submit2' form="shipping_address_form">Submit1</button>
  </div>
</template>
<script>
import { ref, onMounted } from 'vue';
import TButton from "../../../../common/components/buttons/TButton.vue";
import Register from "./NewUser";
import Signin from "../../../authentication/components/Signin";
import DeliveryAddress from "./DeliveryAddress.vue";
import DeliveryMethode from "./DeliveryMethode.vue"
import TInlineMessage from "../../../../common/components/messages/TInlineMessage.vue";
import BillingAddressForm from "../../../userdashboard/components/profile/BillingAddressForm.vue";
import { reactive } from "@vue/reactivity";
import store from "../../../../store";
import CheckoutGeneralFunctions from "../../helpers/CheckoutGeneralFunctions"
import {
  UPDATE_ORDER_BILLING_ADDRESS,
  EDIT_ALL_ORDER_DETAILS,
  GET_PRICE_BREAKDOWN,
  HIDE_CART_DIALOG
} from "../../store/actions";

import { GET_BILLING_ADDRESS, UPDATE_BILLING_ADDRESS} from "../../../userdashboard/store/customer/actions"
import BindingHelper from "../../../../common/helpers/BindingHelper";

export default {
  components: { TButton, TInlineMessage, BillingAddressForm, DeliveryAddress },
  setup() {
    const deliveryAddress = ref(null);
    let billingAddress = reactive(store.getters.orderBillingAddress);
  
    store.dispatch(GET_BILLING_ADDRESS).then((response) => {
      BindingHelper.map(billingAddress, response);
   
    });

    
    let billingValidated = reactive({
      value: false,
    });

    let onValidated = (value) => {
      billingValidated.value = value;
      if (billingValidated.value && deliveryAddress.value.shippingValidated.value){
        goToDeliveryAddress();
      }
    };

    let ErrosLogin = false;

    const goToDeliveryAddress = () => {
      if (
        store.getters.isAuthenticated == true &&
        billingValidated.value == true
      ) {
         store.dispatch(EDIT_ALL_ORDER_DETAILS).then(
        ()=>{
          store.dispatch('getWireTransferInfo',store.getters.orderId)

          store.commit("personnalInfoDisplayActive", false);
          store.commit("deliveryMethodeDisplayActive", true);
          store.commit("checkoutActiveComponent", DeliveryMethode);
          store.commit("deliveryAddressDisplay", false);
          store.commit("displaySummery", true);
          store.commit("setStepperDisplays", [1, 1, 0, 0, 0, 0])

          store.commit("deliveryAddressDisplayActive", false);
          store.commit("updateCheckoutMarketplaceStep", 2)
          store.dispatch(GET_PRICE_BREAKDOWN);

          ErrosLogin = false;
        }
       )
      } else {
        ErrosLogin = true;
      }
    };

    return {
      billingAddress,
      billingValidated,
      onValidated,
      goToDeliveryAddress,
      ErrosLogin,
      deliveryAddress,
    };
  },
  watch: {
    billingAddress: {
      handler(value) {
        value.id = this.$store.getters.orderBillingAddress.id
        this.$store.commit(UPDATE_ORDER_BILLING_ADDRESS, value);    
      
      },
    
      deep: true,
    },
    isAuthenticated: {
      handler: function(newValue, oldValue) {
        if (newValue)
        {
          const {getOrCreateOrder,loadCartItemsFromCookie} = CheckoutGeneralFunctions()
          getOrCreateOrder()
          loadCartItemsFromCookie()
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      tabs: [
        {
          label: "New client",
          component: Register,
          isActive: false,
        },
        {
          label: "Login",
          component: Signin,
          isActive: true,
        },
      ],
    };
  },

  methods: {
    onTabClick(i) {
      this.tabs.forEach((tab, index) => {
        this.ErrosLogin = false;
        if (i == index) {
          tab.isActive = true;
        } else {
          tab.isActive = false;
        }
        this.$store.commit("personnalInfoComponent", this.tabs[i].component);
      });
    },

    submit()
    {
      this.billingValidated = false
      this.$refs.deliveryAddress.shippingValidated.value = false
      document.getElementById("submit2").click()
      document.getElementById("submit1").click()
    },
    async initCheckout()
    {
      this.$store.commit(HIDE_CART_DIALOG)
      if(this.$store.getters.status_id==2)
        this.$store.commit("setStepperDisplays", [1, 1, 1, 1, 1, 0]);
      if (this.isAuthenticated)
      {
        const {getOrCreateOrder,loadCartItemsFromCookie} = CheckoutGeneralFunctions()
        await getOrCreateOrder()
        await loadCartItemsFromCookie()

        BindingHelper.map(this.billingAddress,this.$store.getters.orderBillingAddress)
        BindingHelper.map(this.$refs.deliveryAddress.selectedShippingAddress,this.$store.getters.orderDeliveryAddress)
      }
    }
    
  },
  computed:{
    cartItems() {
      return this.$store.getters.cartItems;
    },
    detailedCartItems()
    {
      return this.$store.getters.detailedCartItems
    },
    isAuthenticated()
    {
      return this.$store.getters.isAuthenticated
    }
  },
  mounted()
  {
    this.initCheckout()
    window.scrollTo(0, 0);
  }
};
</script>
<style lang="scss">
.btn-next {
  margin-top: 50px !important;
}
.submit-button{
  @media screen and (max-width:768px)
  {
    width:100%;
  }
}
@import "../../style/PersonnalInfo.scss";

.personal-info-titles{
  color:$tertiary-color;
  @include f-subtitle2;
}
</style>
